import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import { ButtonPrimary, SuccessFeedbackScreen, skinVars, useWindowSize } from '@telefonica/mistica';
import navigateParams from '../../../../../../utils/navigation/navigateParams';
import { TrackingEvents } from '../../../../../../utils/dataTransformation/tracking';
import { isWebviewIOS, isWebviewAndroid } from '../../../../../../utils/navigation/controlDevices';

export const FeedbackContactVerification: React.FC = () => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const path: any = sessionStorage.getItem('pathOrigin')!;
    const size = useWindowSize();

    const sendToNative = (url: string, title?: string) => {
        const type = 'modeFlow-backgroundBlue';
        const queryParams = {};
        const storage = {};
        if (navigateParams(type, url, queryParams, storage, title)) {
            window.close();
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='feedbackContactVerification-page'
            style={{
                background: size.width < 1024 || size.height < 550 ? skinVars.colors.backgroundBrand : '',
            }}
        >
            <SuccessFeedbackScreen
                title={t('contactVerificationSuccessTitle')}
                description={t('contactVerificationsSuccessSubtitle')}
                primaryButton={
                    <ButtonPrimary
                        onPress={() => {
                            sendToNative(path, 'Perfil');
                        }}
                    >
                        {t('buttonUnderstoodFeedback')}
                    </ButtonPrimary>
                }
            ></SuccessFeedbackScreen>
        </div>
    );
};

export default FeedbackContactVerification;
